/* eslint no-param-reassign: ["error", { "props": false }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HierarchyItem from './hierarchy-item';

import { Button } from '../../../../components';

const styles = {
  button: {
    width: '100%',
  },
};

class HierarchyVisualizer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAll: false,
    };
  }

  addComparison(main, comparison, itemProgressAttribute, fillInZeroes, comparisonIndex) {
    if (!main || main.length < 1) {
      return;
    }

    main.forEach((dataObject) => {
      const { name } = dataObject;

      let hasPushedValue = false;

      comparison.forEach((comparisonDataObject) => {
        if (comparisonDataObject.name === name) {
          if (!dataObject.comparisons) {
            dataObject.comparisons = [];
          }
          hasPushedValue = true;
          if (!dataObject.comparisons.find(c => c.comparisonIndex === comparisonIndex)) {
            dataObject.comparisons.push({ ...comparisonDataObject, comparisonIndex });
          }
        }
      });
      if (fillInZeroes && !hasPushedValue) {
        if (!dataObject.comparisons) {
          dataObject.comparisons = [];
        }
        if (!dataObject.comparisons.find(c => c.comparisonIndex === comparisonIndex)) {
          dataObject.comparisons.push({
            name,
            [itemProgressAttribute]: 0,
            values: [],
            comparisonIndex,
          });
        }
      }

      if (dataObject.comparisons) {
        dataObject.comparisons.forEach((c) => {
          this.addComparison(dataObject.values, c.values, itemProgressAttribute, fillInZeroes, comparisonIndex);
        });
      }
    });
  }

  render() {
    const { data, options, comparisonDateRanges } = this.props;
    const { showAll } = this.state;

    let itemProgressAttribute = options.itemProgressAttribute
      || ((options.sortableAttributes && options.sortByAttribute)
        ? options.sortableAttributes[options.sortByAttribute].groupAttribute : null);

    // name is not a valid itemProgressAttribute, look for a different one instead
    if (itemProgressAttribute === 'name') {
      const sortAttributes = options.sortableAttributes
        ? Object.entries(options.sortableAttributes).map(sortable => sortable[1]) : [];
      itemProgressAttribute = sortAttributes.find(attribute => attribute.groupAttribute !== 'name').groupAttribute;
    }

    if (!itemProgressAttribute) {
      console.warn('Please provide a progress attribute option');
      return 'Bitte überprüfen Sie die Widgetkonfiguration ';
    }

    const sortableAttribute = options.sortableAttributes && options.sortableAttributes[options.sortByAttribute];

    const comparisonData = data.slice(1);
    comparisonData.forEach((cd, i) => this.addComparison(data[0], cd, itemProgressAttribute, data.length > 2, i));

    const reducer = options.compareToTotal ? (a, b) => a + b : (a, b) => (a > b ? a : b);
    const total = data[0].length > 0 ? data[0].map(d => d[itemProgressAttribute]).reduce(reducer, 0) : 0;

    const moreRowsAvailable = data[0].length > 10;
    const selectedData = showAll ? data[0] : data[0].slice(0, 10);

    const hierarchyItems = selectedData.map(d => (
      <HierarchyItem
        key={d.name}
        title={options.title}
        decimals={sortableAttribute?.decimals == null ? options.decimals : sortableAttribute?.decimals}
        data={d}
        progress={d[itemProgressAttribute] / total * 100}
        total={total}
        itemProgressAttribute={itemProgressAttribute}
        level={0}
        showGroupDetails={options.showGroupDetails}
        hideProgress={options.hideProgress}
        suffix={options.hideValueSuffix ? '' : sortableAttribute?.suffix || options.currencySymbol}
        tooltip={options.tooltip}
        comparisonDateRanges={comparisonDateRanges}
      />
    ));

    return (
      <div>
        {hierarchyItems}
        {moreRowsAvailable
        && (
          <Button
            style={styles.button}
            onClick={() => this.setState({ showAll: !showAll })}
          >
            {showAll ? 'Weniger anzeigen' : 'Mehr anzeigen'}
          </Button>
        )
        }
      </div>
    );
  }
}

HierarchyVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  comparisonDateRanges: PropTypes.array.isRequired,
};

HierarchyVisualizer.defaultProps = {
  data: [],
  options: [],
};

export default HierarchyVisualizer;
